import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { useTheme } from "@mui/material";
import { getRemaining } from "@src/components/RichTextEditor/Util/getRemaining";

interface CharacterCountViewProps {
  stripped?: string;
  limit?: number;
}

export const CharacterCountView = ({
  stripped,
  limit,
}: CharacterCountViewProps) => {
  const remaining = getRemaining(stripped, limit);
  const theme = useTheme();
  if (remaining === undefined) {
    return null;
  }
  return (
    <IgTypography
      variant={"body3"}
      sx={{ color: theme.palette.text.secondary }}
    >
      {remaining} / {limit} characters remaining
    </IgTypography>
  );
};
